/**
 * Chemins du journal d'audit.
 *
 * Module **pur**, importe par l'ecran comme par le registre de navigation
 * (`src/ui/navigation.ts`), qui doit rester testable sans monter React Admin.
 *
 * Le journal est un ecran liste + detail (`MasterDetail`) : une seule route
 * `<base>/*` le monte, et la selection (`<base>/<id>`) vit dans l'URL. Le
 * registre pointe la **base**, la route declaree dans `App.tsx` porte le `/*`.
 */

export const AUDIT_PATH = '/compliance/audit';

export const AUDIT_ROUTE = `${AUDIT_PATH}/*`;
